const SHARED_LINK_COMPLETE_MESSAGE = 'Thank you! \nYour Application has been successfully sent.';

export default SHARED_LINK_COMPLETE_MESSAGE;
